var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', [_c('v-layout', {
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "400"
    }
  }, [_c('v-card-title', [_vm._v(" 로그인이 필요한 페이지입니다 ")]), _c('v-card-text', [_c('login-card')], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }